import { Link } from 'react-router-dom';
import { mediaList } from '@/mocks/movies';

const quickEntries = [
  {
    type: '电影',
    title: '电影',
    desc: '院线与线上新片，按档期整理',
    icon: 'ri-film-line',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20seat%20row%20with%20warm%20amber%20screen%20light%20abstract%20minimal%20composition%2C%20deep%20green%20shadows%2C%20soft%20grain%2C%20no%20text&width=600&height=400&seq=boluomi-entry-movie&orientation=landscape',
  },
  {
    type: '电视剧',
    title: '电视剧',
    desc: '长剧与短剧，追剧不漏更',
    icon: 'ri-tv-2-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20warm%20amber%20lamp%20and%20soft%20green%20curtains%2C%20abstract%20minimal%20composition%2C%20cinematic%20texture%2C%20no%20text&width=600&height=400&seq=boluomi-entry-tv&orientation=landscape',
  },
];

export default function QuickEntries() {
  const hot = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 4);

  return (
    <section className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {quickEntries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${encodeURIComponent(entry.type)}`}
          className="group relative h-[150px] overflow-hidden rounded-lg bg-background-800"
        >
          <img
            src={entry.image}
            alt={`${entry.title}分类入口`}
            title={`${entry.title}分类入口 菠萝蜜网`}
            className="absolute inset-0 h-full w-full object-cover opacity-80 transition duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-background-950/90 via-background-950/55 to-transparent" />
          <div className="relative flex h-full flex-col justify-end p-4">
            <span className="mb-2 flex h-8 w-8 items-center justify-center rounded-md bg-primary-500/90 text-background-50">
              <i className={`${entry.icon} text-base`} />
            </span>
            <h3 className="font-heading text-base font-bold text-background-50">{entry.title}</h3>
            <p className="mt-1 text-[11px] text-background-200/80">{entry.desc}</p>
          </div>
        </Link>
      ))}

      <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-base font-bold text-accent-900">热门推荐</h3>
          <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium text-background-50">TOP 4</span>
        </div>
        <ul className="mt-2 divide-y divide-accent-200/70">
          {hot.map((item, index) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="flex items-center gap-2 py-1.5 transition hover:opacity-80">
                <span className="w-3.5 text-center font-heading text-xs font-bold text-accent-700">{index + 1}</span>
                <span className="flex-1 truncate text-xs text-foreground-900">{item.title}</span>
                <span className="text-[10px] text-foreground-500">{item.type}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}